package org.gymly.ui.admin

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.theme.AdminColors

/** Motivos de inactivación de clientes: código que guarda el backend y etiqueta que ve el personal. */
val CLIENT_INACTIVATION_REASONS = listOf(
    "BAJA_VOLUNTARIA" to "Baja voluntaria",
    "SUSPENSION_DISCIPLINARIA" to "Suspensión disciplinaria",
    "RESTRICCION_SALUD" to "Restricción de salud o seguridad",
    "REGISTRO_DUPLICADO" to "Registro duplicado o con error",
    "FALLECIMIENTO" to "Fallecimiento",
    "OTRO" to "Otro",
)

/**
 * Motivo que pone el sistema solo (vencimiento sin renovar). Se muestra en la ficha,
 * pero no se ofrece en el selector: el personal no lo elige a mano.
 */
val CLIENT_AUTO_INACTIVATION_REASON = "VENCIMIENTO_SIN_RENOVAR" to "Vencimiento sin renovar"

/** Motivos de inactivación de trabajadores. */
val STAFF_INACTIVATION_REASONS = listOf(
    "RENUNCIA" to "Renuncia",
    "DESPIDO" to "Despido",
    "FIN_CONTRATO" to "Fin de contrato",
    "SUSPENSION_DISCIPLINARIA" to "Suspensión disciplinaria",
    "OTRO" to "Otro",
)

/**
 * Selector de motivo de inactivación con nota obligatoria cuando el motivo es "OTRO".
 * Se muestra solo cuando la persona queda inactiva.
 */
@Composable
fun InactivationReasonFields(
    reasons: List<Pair<String, String>>,
    reason: String?,
    onReasonChange: (String) -> Unit,
    note: String,
    onNoteChange: (String) -> Unit,
    enabled: Boolean,
) {
    var menu by remember { mutableStateOf(false) }
    Text("Motivo de inactivación *", fontWeight = androidx.compose.ui.text.font.FontWeight.SemiBold, color = AdminColors.Text, fontSize = 13.sp)
    Spacer(Modifier.height(4.dp))
    Box {
        OutlinedButton(onClick = { menu = true }, enabled = enabled, modifier = Modifier.fillMaxWidth()) {
            Text(reasons.firstOrNull { it.first == reason }?.second ?: "Seleccionar", color = AdminColors.Text)
        }
        DropdownMenu(expanded = menu, onDismissRequest = { menu = false }) {
            reasons.forEach { (code, label) ->
                DropdownMenuItem(
                    text = { Text(label) },
                    onClick = {
                        onReasonChange(code)
                        menu = false
                    },
                )
            }
        }
    }
    if (reason == "OTRO") {
        Spacer(Modifier.height(8.dp))
        OutlinedTextField(
            value = note,
            onValueChange = onNoteChange,
            enabled = enabled,
            modifier = Modifier.fillMaxWidth(),
            singleLine = true,
            placeholder = { Text("Describe el motivo", color = AdminColors.TextMuted) },
            shape = RoundedCornerShape(10.dp),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = AdminColors.Primary,
                unfocusedBorderColor = AdminColors.Outline,
            ),
        )
    }
}
